import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; 

export const LanguagesPage = () => {
  const [languages, setLanguages] = useState([]);

  const navigate = useNavigate(); 

  useEffect(() => {
    axios.get("http://localhost:1337/api/languages?populate=guides")
      .then(response => {
        console.log("API Response:", response.data.data);
        setLanguages(response.data.data || []);
      })
      .catch(error => console.error("Error fetching data:", error));
  }, []);

  
  const handleLanguageClick = (language) => {
    if (!language.id) {
      console.warn("Invalid language ID:", language);
      return;
    }
    navigate(`/languages/${language.id}`); 
  };
  

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <nav className="bg-green-600 p-4 text-white text-center text-lg font-bold">
        Languages
      </nav>
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-6 mt-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Select a Language</h1>
        <div className="space-y-4">
          {languages.length > 0 ? (
            languages.map(lang => {
              return (
              <div
                key={lang.id}
                className="bg-blue-500 text-white text-xl font-semibold p-4 rounded-lg cursor-pointer hover:bg-blue-700 transition"
                onClick={() => handleLanguageClick(lang)} 
              >
                {lang.name || "Unknown"}
              </div>
      
            )
          })
          ) : (
            <p className="text-center text-gray-500">No languages available</p>
          )}
        </div>
      </div>
    </div>
  );
};
